import { listCategories } from '@wix/ambassador-faq-category-v2-category/http';
import { SortOrder } from '@wix/ambassador-faq-category-v2-category/types';
import {
  listQuestionEntries,
  queryQuestionEntries,
} from '@wix/ambassador-faq-question-entry-v2-question-entry/http';
import { QueryQuestionEntriesRequest } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import { IHttpClient } from '@wix/http-client';

export const getListCategoriesAPI = async (httpClient: IHttpClient) => {
  const response = await httpClient.request(listCategories({}));

  while (response.data.pagingMetadata?.hasNext) {
    const nextCursor = response.data.pagingMetadata.cursors?.next;

    const nextResponse = await httpClient.request(
      listCategories({
        paging: nextCursor ? { cursor: nextCursor } : undefined,
      }),
    );

    response.data.categories!.push(...nextResponse.data.categories!);
    response.data.pagingMetadata = nextResponse.data.pagingMetadata;
  }

  return response.data;
};
export const getListQuestionsAPI = async ({
  categoryId,
  cursor,
  limit = 50,
  httpClient,
  isSEO = false,
}: {
  categoryId?: string | null | undefined | (string | null | undefined)[];
  limit?: number;
  cursor?: string;
  httpClient: IHttpClient;
  isSEO?: boolean;
}) => {
  const requestPayload: QueryQuestionEntriesRequest = {
    query: {
      cursorPaging: { cursor, limit },
    },
  };

  if (!cursor && requestPayload.query) {
    requestPayload.query.filter = { categoryId };
    requestPayload.query.sort = [
      { fieldName: 'sortOrder', order: SortOrder.ASC },
    ];
  }

  const response = await httpClient.request(
    queryQuestionEntries(requestPayload),
  );
  if (isSEO) {
    while (response.data.pagingMetadata?.hasNext) {
      const nextCursor = response.data.pagingMetadata.cursors?.next;

      const nextResponse = await httpClient.request(
        listQuestionEntries({
          paging: nextCursor ? { cursor: nextCursor } : undefined,
        }),
      );

      response.data.questionEntries!.push(
        ...nextResponse.data.questionEntries!,
      );
      response.data.pagingMetadata = nextResponse.data.pagingMetadata;
    }
  }
  return response.data;
};
export const getSearchTermAPI = async ({
  term,
  cursor,
  httpClient,
}: {
  term?: string;
  cursor?: string;
  httpClient: IHttpClient;
}) => {
  term = '%' + `${term}`.trim().replaceAll(' ', '%');

  let requestPayload: QueryQuestionEntriesRequest;

  if (!cursor) {
    // on initial load
    requestPayload = {
      query: {
        filter: {
          $or: [
            {
              draftjs: {
                $startsWith: term,
              },
            },
            {
              question: {
                $startsWith: term,
              },
            },
          ],
        },
        sort: [{ fieldName: 'sortOrder', order: SortOrder.ASC }],
      },
    };
  } else {
    // on load more
    requestPayload = {
      query: {
        cursorPaging: { cursor },
      },
    };
  }

  const response = await httpClient.request(
    queryQuestionEntries(requestPayload),
  );

  return {
    questionEntries: response.data?.questionEntries || [],
    pagingMetadata: response.data?.pagingMetadata || {},
  };
};
export const getQuestionAPI = async ({
  id,
  httpClient,
}: {
  id?: string | null | undefined | (string | null | undefined)[];
  httpClient: IHttpClient;
}) => {
  const response = await httpClient.request(
    queryQuestionEntries({
      query: {
        filter: { id },
        sort: [{ fieldName: 'sortOrder', order: SortOrder.ASC }],
      },
    }),
  );
  return response.data;
};
